module.exports = __webpack_public_path__ + "static/banner-image-2-d9d36776a5c392267745b29535ade2ed.png";